import { arrayOf, shape, string } from "prop-types"
import { useContext } from "react"
import ReactDatePicker from "react-datepicker"
import { AlertMessage } from "source/shared/AlertMessage"
import { capitalize } from "lodash"
import { WebBootContext } from "source/publishing/WebBoot"

function FormErrors({ message, errors = [] }) {
  if (!errors.length) return null

  const messages = errors.map(({ detail, source: { parameter } }) => {
    if (parameter === "base" || parameter === "destination") {
      return detail
    } else {
      return `${capitalize(parameter.replace("_", " "))} ${detail}`
    }
  })

  return (
    <AlertMessage className="mb-2">
      {message}
      <ul className="mt-1">
        {messages.map((m) => (
          <li key={m} className="mt-1">
            {m}
          </li>
        ))}
      </ul>
    </AlertMessage>
  )
}
FormErrors.propTypes = {
  errors: arrayOf(
    shape({
      detail: string,
      source: shape({ parameter: string }),
    }),
  ),
  message: string,
}

function DateInput(props) {
  const {
    currentOrganization: {
      attributes: { datetime_fmt_configuration },
    },
  } = useContext(WebBootContext)

  return (
    <ReactDatePicker
      placeholder="Select a date"
      wrapperClassName="w-100%"
      showPopperArrow={false}
      dateFormat={
        datetime_fmt_configuration.dateFirst ? "d/MM/yyyy" : "M/d/yyyy"
      }
      {...props}
    />
  )
}

function TimeInput(props) {
  const {
    currentOrganization: {
      attributes: { datetime_fmt_configuration },
    },
  } = useContext(WebBootContext)

  return (
    <ReactDatePicker
      placeholder="Select a time"
      wrapperClassName="w-100%"
      showPopperArrow={false}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      dateFormat={datetime_fmt_configuration.hour12 ? "h:mmaaa" : "HH:mm"}
      timeFormat={datetime_fmt_configuration.hour12 ? "h:mmaaa" : "HH:mm"}
      {...props}
    />
  )
}

const Form = {
  DateInput,
  TimeInput,
  Errors: FormErrors,
}

export default Form
